import { useCallback } from "react";

import { useTerminalContext } from "../contexts/TerminalContext";
import { configApi, ConfigFileFilter } from "../services/configApi";
import { createWithLoading, wrapError } from "../utils/configApiHelpers";

/**
 * Hook for listing config files for a terminal
 */
export const useConfigFileList = () => {
  const { setFileList, setIsLoading } = useTerminalContext();

  const listConfigFiles = useCallback(
    async (terminalId: number, filter?: ConfigFileFilter, signal?: AbortSignal) => {
      const withLoading = createWithLoading(setIsLoading);
      return withLoading(async () => {
        try {
          const files = await configApi.fetchConfigFiles(terminalId, filter, signal);
          setFileList(files);
        } catch (error: any) {
          console.error("Failed to load config files:", error);
          setFileList([]);
          throw wrapError("Failed to load config files", error);
        }
      });
    },
    [setFileList, setIsLoading]
  );

  return { listConfigFiles };
};
